import { render, staticRenderFns } from "./ConversationTranslation.vue?vue&type=template&id=187d479c&"
import script from "./ConversationTranslation.vue?vue&type=script&lang=js&"
export * from "./ConversationTranslation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports